import { SkillsIdeateStep, SkillsIdeateStepI } from '@core/tellent-skills-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { SkillsIdeateErrorDialogComponent } from '../skills-ideate-error-dialog/skills-ideate-error-dialog.component';
import { SkillsIdeateIntroDialogComponent } from '../skills-ideate-intro-dialog/skills-ideate-intro-dialog.component';
import { SkillsIdeateLoadingDialogComponent } from '../skills-ideate-loading-dialog/skills-ideate-loading-dialog.component';
import { SkillsIdeateOptionsDialogComponent } from '../skills-ideate-options-dialog/skills-ideate-options-dialog.component';
import { SkillsIdeateResultDialogComponent } from '../skills-ideate-result-dialog/skills-ideate-result-dialog.component';

export const skillsIdeateStepComponentMap: Record<SkillsIdeateStep, SkillsIdeateStepI> = {
  intro: {
    dialogComponent: SkillsIdeateIntroDialogComponent,
    dialogConfig: { width: DialogWidth.Large, containerOptions: { fullscreenOnMobile: true } },
  },
  generate_options: {
    dialogComponent: SkillsIdeateOptionsDialogComponent,
    dialogConfig: { width: DialogWidth.Large, containerOptions: { fullscreenOnMobile: true } },
  },
  loading: {
    dialogComponent: SkillsIdeateLoadingDialogComponent,
    dialogConfig: {
      width: DialogWidth.Large,
      containerOptions: { fullscreenOnMobile: true },
    },
  },
  result: {
    dialogComponent: SkillsIdeateResultDialogComponent,
    dialogConfig: {
      width: DialogWidth.Large,
      containerOptions: { fullscreenOnMobile: true },
    },
  },
  result_error: {
    dialogComponent: SkillsIdeateErrorDialogComponent,
    dialogConfig: {
      width: DialogWidth.SmallX,
      containerOptions: { fullscreenOnMobile: true },
    },
  },
};
